// extracted by css-extract-rspack-plugin
export default {"wrapper":"_ab5d1385"};